import { useState, Children, cloneElement } from 'react'
import styled from 'styled-components'
import { Content } from './AccordionItem'
import { AccordionId } from './types'

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    ${Content} {
      border-bottom: 0.1px solid var(--gray-3);
    }

    &:last-child {
      ${Content} {
        border-bottom: 0;
      }
    }
  }
`

// TODO: fix any
const AccordionContainer: React.FC<any> = ({ children, ...props }) => {
  const [active, setActive] = useState<AccordionId | null>(null)

  const handleClick = (newId: AccordionId) => {
    setActive((id) => (newId === id ? null : newId))
  }

  return (
    <List {...props}>
      {Children.map(children, (child) =>
        cloneElement(child as any, {
          onClick: handleClick,
          activeId: active,
        }),
      )}
    </List>
  )
}

export default AccordionContainer
